export const getOrganisation = (organisationId) => ({ organisations }) =>
  organisations.organisationsList.find(({ id }) => id === organisationId);